import React from 'react';
import {connect} from 'react-redux';
import Tone from 'tone';
import PulseLoader from 'react-spinners/PulseLoader'
const WIDTH = 380;

const ExportProgressBar = ({currentTime=0, renderLength, width=WIDTH, currentExportInfo}) => {
    const barTime = new Tone.Time('1n').toMilliseconds() / 1000.0;
    const totalRenderSize = renderLength * barTime;
    let loadingProgress = currentTime / totalRenderSize;
    let style = {
        width: width * loadingProgress
    };
    let info = currentExportInfo;
    
    return (
        <div className="progress-bar">
          <div className="inner-progress-bar">
          <div className="progress" style={style}/>
            <div className="loading-text">
              {info ?
               "Exporting " + info.name + " " + (info.index + 1) + "/" + info.total + " ": 
               "Exporting Project "}
              ({Math.round(loadingProgress * 100.0)}%)... 
            </div>
          </div>
        </div>
    );
};

const mapStateToProps = (state, {sequencerEngine, id, renderLength})=> {
    return {
        currentTime : state.freeze.offlineEngine && state.freeze.offlineEngine.context &&
            Math.floor(state.freeze.offlineEngine.context._context.currentTime),
        currentExportInfo: state.freeze.currentExportInfo
    };
};


export default connect(mapStateToProps, null)(ExportProgressBar);
